<template>
  <div>
    <div class="row">
      <div class="col-8">
        <breadcrumb :page="page" />
      </div>
      <div class="col-4">
        <div class="d-flex justify-content-end">
          <action-button
            class="m-2"
            i="fas fa-arrow-circle-left"
            variant="success"
          >
            Regresar
          </action-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dropdown-divider mt-0 pb-2 ml-3 w-100 line" />
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="custom-fiscal-year">
          <p>Año Fiscal</p>
          <custom-drop-down
            class="custom-fiscal-year-select"
            fieldkey="id"
            fieldname="name"
            label
            placeholder="Seleccione"
            required
          />
        </div>
      </div>
      <div class="col-8">
        <div class="custom-selected">
          <p>150 Seleccionados</p>
        </div>
      </div>
    </div>

    <div class="col-12 custom-tab-container">
      <div class="no-margin-bottom">
        <div class="custom-left-separator" />
        <div class="custom-tab-content">
          <ul class="tab-list nav nav-pills mb-3" role="tablist">
            <li
              v-for="item in this.visibleTabs(tabs)"
              :key="item.Id"
              :class="'nav-item-Sub-menu text-center ' + tabRender(item.Name)"
            >
              <a
                aria-controls="tab-i"
                aria-selected="true"
                class="nav-link no-margin-left"
                :class="{ active: isActive(item.Name) }"
                href="#tab-i"
                role="tab"
                @click.prevent="setActive(item.Id)"
              >
                {{ item.Caption }}
              </a>
            </li>
          </ul>
        </div>
        <div class="custom-right-separator" />
      </div>
      <div class="tab-content">
        <keep-alive>
          <component
            :is="activeTab"
            ref="currenTab"
            v-bind="currentProperties"
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import Tab1 from './components/Tab1';
import Tab2 from './components/Tab2';
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/form/CustomDropDown';

export default {
  name: 'EvaluatorManagement',
  components: {
    Tab1: Tab1,
    Tab2: Tab2,
    store,
    breadcrumb,
    ActionButton,
    CustomDropDown,
  },

  data() {
    return {
      page: {
        icon: 'fas fa-user-tie',
        title: 'Manejo de Evaluadores',
        routes: ['Proveedor', 'Manejo de Evaluadores'],
        sections: ['Búsqueda'],
      },
      leftTab: '',
      rightTab: '',
      activeTab: 'Tab1',
      tabs: [
        {
          Id: 'Tab1',
          Name: 'Tab1',
          Caption: 'Listado de Evaluadores Seleccionados',
          page: {
            tabIndex: 1,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'Listado de Evaluadores Seleccionados',
            routes: [],
            tooltip: 'Listado de Evaluadores Seleccionados',
          },
        },
        {
          Id: 'Tab2',
          Name: 'Tab2',
          Caption: 'Listado de Usuarios Disponibles',
          page: {
            tabIndex: 2,
            icon: 'fas fa-user-edit orange-icon fa-lg',
            title: 'Listado de Usuarios Disponibles',
            routes: [],
            tooltip: 'Listado de Usuarios Disponibles',
          },
        },
      ],
      Tabs: {
        Name: 'EvaluatorManagement Tab',
        Tab1Tab: {
          Name: 'Tab I',
        },
        Tab2Tab: {
          Name: 'Tab II',
        },
      },
    };
  },
  computed: {
    currentProperties: function() {
      return { Info: this.Tabs[this.activeTab + 'Tab'] };
    },
    currentTabHeaderInfo() {
      const currentTab = this.tabs.find((t) => t.Id === this.activeTab);
      return currentTab.page;
    },
  },
  mounted() {
    const self = this;
    const { tab } = self.$root.$route.query;
    if (tab) {
      self.activeTab = tab;
    }
  },
  methods: {
    isActive(menuItem) {
      return this.activeTab === menuItem;
    },
    async setActive(menuItem) {
      this.activeTab = menuItem;
    },
    checkVisibility(tab) {
      return tab.isVisible;
    },
    visibleTabs(tabs) {
      this.setTabsVisiblitiy();
      return tabs.filter(this.checkVisibility);
    },
    setTabsVisiblitiy() {
      this.tabs.forEach((tab) => {
        if (tab.Id == 'Tab1' || tab.Id == 'Tab2') {
          tab.isVisible = true;
        }
      });
    },
    saveTab() {
      if (this.currentTabHeaderInfo.tabIndex == 9) {
        let child = this.$refs.currenTab;
        child.handleSubmit();
      }
    },
    reRender() {
      this.$emit('reRender');
    },
    tabRender(tab) {
      return tab == 'Tab1' ? 'tab-left' : 'tab-right';
    },
  },
};
</script>

<style scoped>
.nav {
  width: 100%;
  border-radius: 25px;
  background: #f2f2f2;
}

.nav-item-Sub-menu {
  width: 345px;
  background: none;
  height: 31px;
}
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}

.txt {
  padding-top: 8%;
  width: initial;
  line-height: 110%;
  white-space: pre-wrap;
}
.no-margin-bottom {
  margin-bottom: 0px;
  margin-top: 25px;
  float: left;
  width: 100%;
}

.no-margin-left {
  margin-left: 0px !important;
}

.custom-fiscal-year {
  float: left;
  width: 100%;
  margin-left: 15px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  padding: 15px 15px 15px 15px;
}

.custom-fiscal-year p {
  float: left;
  margin-bottom: 0px;
  margin-top: 5px;
}

.custom-fiscal-year-select {
  float: left;
  width: 70%;
  margin-left: 15px;
}

.nav-pills .nav-link {
  height: 30px;
  padding: 5px;
  background: #f2f2f2;
}

.nav-pills .nav-link.active {
  background-color: #3f5b60 !important;
  z-index: 999;
}

.nav-link.active:after {
  display: none;
}

.custom-left-separator {
  float: left;
  width: 205px;
  height: 2px;
  background: #f2f2f2;
  margin-right: 10px;
  margin-top: 14px;
}

.custom-right-separator {
  float: left;
  width: 255px;
  height: 2px;
  background: #f2f2f2;
  margin-top: 14px;
  margin-left: 8px;
}

.custom-tab-content {
  float: left;
}

li.nav-item-Sub-menu.text-center.tab-left > a {
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
}

li.nav-item-Sub-menu.text-center.tab-left > a.active {
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
}

li.nav-item-Sub-menu.text-center.tab-right > a.active {
  border-bottom-right-radius: 25px;
  border-top-right-radius: 25px;
}

li.nav-item-Sub-menu.text-center.tab-right > a {
  border-bottom-right-radius: 25px;
  border-top-right-radius: 25px;
}

.custom-selected {
  float: right;
  border-color: #f2f2f2;
  border-width: 2px;
  border-style: solid;
  padding: 10px 15px 10px 15px;
}

.custom-selected p {
  text-align: center;
  margin-bottom: 0px;
  font-size: 15px;
  color: #8a8484;
}

.custom-tab-container {
  padding: 0px !important;
  margin-left: 15px;
}

@media (max-width: 768px) {
  .custom-fiscal-year {
    width: 300px;
  }

  .no-margin-bottom {
    width: 40px;
    margin-left: 13%;
  }
}

@media (max-width: 1024px) {
  .custom-fiscal-year-select {
    width: 60%;
  }

  .custom-left-separator,
  .custom-right-separator {
    display: none;
  }

  .custom-tab-content {
    margin-left: 8%;
  }
}
</style>
